import { Box, Button, Flex, Text, useBreakpointValue } from "@chakra-ui/react";
import FilterCard from "./FilterCard";
import { dimensionsKeys } from "../../../../../../utils";
import { useTranslation } from "react-i18next";
import { getLowestFilteredDimensionKey } from "./helpers";

function FiltersSection({ filtersData, removeFilter, clearAll, handleExportClick }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage"
  });
  const exportBtnOnSameLine = useBreakpointValue({
    xl: true,
    base: false
  });
  const fourItemsContainerWidth = useBreakpointValue({
    "2xl": "80%",
    xl: "70%",
    base: "100%"
  });
  const fiveItemsContainerWidth = useBreakpointValue({
    "2xl": "75%",
    base: fourItemsContainerWidth
  });

  return (
    filtersData && Object.keys(filtersData).length > 0 ?
      <>
        <Flex gap={5} justifyContent="space-between" alignItems="center">
          <Flex
            gap={5}
            alignItems="center"
            maxWidth={Object.keys(filtersData).length > 4 ? fiveItemsContainerWidth : fourItemsContainerWidth}
          >
            <Flex overflow="auto" gap={5}>
              {Object.keys(filtersData)
                .sort((a, b) => dimensionsKeys.indexOf(a) - dimensionsKeys.indexOf(b))
                .map(filterKey => {
                  const data = filtersData[filterKey];
                  const lowestFilteredDimensionKey = getLowestFilteredDimensionKey(filtersData);
                  return data.items.map(item => {
                    const dataObj = {
                      ...data,
                      item
                    }
                    return <Box key={`${data.dimensionName}-${item.id}`} width="min-content">
                      <FilterCard
                        data={dataObj}
                        remove={() => removeFilter(filterKey, item)}
                        isIncludedInReport={filterKey === lowestFilteredDimensionKey}
                      />
                    </Box>
                  })
                })
              }
            </Flex>
            <Text
              textDecoration="underline"
              color="green.600"
              fontWeight="700"
              cursor="pointer"
              minWidth="max-content"
              onClick={clearAll}
            >
              {t("scope1&2.dimension.clearAll")}
            </Text>
          </Flex>
          {exportBtnOnSameLine ? <Button
            colorScheme="customScheme"
            minWidth="max-content"
            title={t("buttons.scope1&2ExportTooltip")}
            onClick={handleExportClick}
          >
            {t("buttons.exportScope1&2")}
          </Button> : null}
        </Flex>
        {!exportBtnOnSameLine ? <Button
          colorScheme="customScheme"
          marginTop={5}
          title={t("buttons.scope1&2ExportTooltip")}
          onClick={handleExportClick}
        >
          {t("buttons.exportScope1&2")}
        </Button> : null}
      </>
      :
      <Flex height="40px" alignItems="center">
        <Text fontSize="lg" fontWeight="bold">
          {t("scope1&2.dimension.noDataAvailable")}
        </Text>
      </Flex>
  );
}

export default FiltersSection;